import React from "react";
import Card from "react-bootstrap/Card";
import { Trans, useTranslation } from "react-i18next";

function StoryCardShell({ title, children }) {
  return (
    <Card className="policy-card story-card">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          {title ? <h3 className="story-card-title">{title}</h3> : null}
          {children}
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export function StoryBeginningCard() {
  const { t } = useTranslation();
  return (
    <StoryCardShell title={t("story.cards.beginning.title")}>
      <p className="about-text">
        <Trans i18nKey="story.cards.beginning.p1" components={{ purple: <span className="purple" /> }} />
      </p>
      <p className="about-text">
        {t("story.cards.beginning.p2")}
      </p>
      <p className="about-text">
        {t("story.cards.beginning.p3")}
      </p>
    </StoryCardShell>
  );
}

export function StorySimorghCard() {
  const { t } = useTranslation();
  return (
    <StoryCardShell title={t("story.cards.simorgh.title")}>
      <p className="about-text">
        <Trans i18nKey="story.cards.simorgh.p1" components={{ purple: <span className="purple" /> }} />
      </p>
      <p className="about-text">
        {t("story.cards.simorgh.p2")}
      </p>
    </StoryCardShell>
  );
}

export function StoryTruthCard() {
  const { t } = useTranslation();
  return (
    <StoryCardShell title={t("story.cards.truth.title")}>
      <p className="about-text">
        <Trans i18nKey="story.cards.truth.p1" components={{ purple: <span className="purple" /> }} />
      </p>
      <p className="about-text">
        {t("story.cards.truth.p2")}
      </p>
    </StoryCardShell>
  );
}

export function StoryForwardCard() {
  const { t } = useTranslation();
  return (
    <StoryCardShell title={t("story.cards.forward.title")}>
      <p className="about-text">
        <Trans i18nKey="story.cards.forward.p1" components={{ purple: <span className="purple" /> }} />
      </p>
      <p className="about-text">
        <Trans i18nKey="story.cards.forward.p2" components={{ purple: <span className="purple" /> }} />
      </p>
      <p className="about-text">
        {t("story.cards.forward.p3")}
      </p>
    </StoryCardShell>
  );
}

export default StoryBeginningCard;
